<template>
    <div class="col-12">
        <h5> Static questions labels </h5>

        <div
            v-for="({ text, key }, index) in staticFields"
            :key="key + index"
            class="form-group col-12"
        >
            <label :for="key">{{ text }}</label>
            <input
                :id="key"
                v-model="labels[key]"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': !!getError(key)
                }"
                dir="auto"
            />

            <div class="invalid-feedback">
                {{ getError(key) }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true
        },

        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            staticFields: [
                { text: 'Name', key: 'name' },
                { text: 'Subname', key: 'subname' },
                { text: 'Title', key: 'title' },
                { text: 'Subtitle', key: 'subtitle' },
                { text: 'Description', key: 'description' },
                { text: 'Image', key: 'featuredImage' }
            ],
            labels: {}
        };
    },

    watch: {
        labels() {
            this.$emit('input', this.labels);
        }
    },

    mounted() {
        this.labels = { ...this.value };
    },

    methods: {
        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                {},
                this.serverErrors,
                `labels.${key}`
            );
        }
    }
};
</script>
